let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kdPRu")).then(() => parcelRequire('7aWQw'));